import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError, Observable, of } from 'rxjs';
import { ToastService } from './toasts.service';
import {
  PlanogramSummaryResults,
  RecentEventResults,
} from '../models/sharing-center';
import { PlanogramSharedUserDTO, UserDTO } from '../models/user';

@Injectable({
  providedIn: 'root',
})
export class SharingCenterService {
  private apiUrl = `${environment.apiUrl}/sharingcenter`;

  constructor(private http: HttpClient, private toastService: ToastService) {}

  getPlanogramSummaries(
    page: number = 1,
    pageSize: number = 10,
    searchTerm: string,
    sortBy: string,
    sortAsc: boolean
  ): Observable<PlanogramSummaryResults | null> {
    const url = `${this.apiUrl}/planogram-summaries?page=${page}&pageSize=${pageSize}&searchTerm=${searchTerm}&sortBy=${sortBy}&sortAsc=${sortAsc}`;
    return this.http
      .get<PlanogramSummaryResults>(url, {
        withCredentials: true,
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      })
      .pipe(
        catchError(() => {
          this.toastService.show('Failed to fetch planogram summaries', {
            classname: 'bg-danger text-light p-3 fs-5',
          });
          return of(null);
        })
      );
  }

  getRecentEvents(
    page: number = 1,
    pageSize: number = 20
  ): Observable<RecentEventResults | null> {
    const url = `${this.apiUrl}/recent-events?page=${page}&pageSize=${pageSize}`;
    return this.http
      .get<RecentEventResults>(url, {
        withCredentials: true,
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      })
      .pipe(
        catchError(() => {
          this.toastService.show('Failed to load recent events', {
            classname: 'bg-danger text-light p-3 fs-5',
          });
          return of(null);
        })
      );
  }

  getPlanogramSharedUsers(planogramId: string): Observable<PlanogramSharedUserDTO[] | null> {
    const url = `${this.apiUrl}/planogram-shared-users/${planogramId}`;
    return this.http
      .get<PlanogramSharedUserDTO[]>(url, {
        withCredentials: true,
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      })
      .pipe(
        catchError(() => {
          this.toastService.show('Failed to load shared users', {
            classname: 'bg-danger text-light p-3 fs-5',
          });
          return of(null);
        })
      );
  }

  getPlanogramEventsByUser(
    planogramId: string,
    userId: string,
    page = 1,
    pageSize = 20
  ): Observable<RecentEventResults | null> {
    const url = `${this.apiUrl}/planogram-events/${planogramId}/${userId}?page=${page}&pageSize=${pageSize}`;
    return this.http
      .get<RecentEventResults>(url, {
        withCredentials: true,
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      })
      .pipe(
        catchError(() => {
          this.toastService.show('Failed to load events for user', {
            classname: 'bg-danger text-light p-3 fs-5',
          });
          return of(null);
        })
      );
  }
}
